<template>
  <div>
    <div>
      You are about to send this cohort for clinical verification.
      <v-tooltip top>
        <v-icon class="help-icon" color="primary" small slot="activator">mdi-information-outline</v-icon>
        <span>Clinical verification is the process where submitted data is reviewed for accuracy and compliance by clinical experts.</span>
      </v-tooltip>
    </div>
    <div>
      Once submitted, no further edits can be made.
      <v-tooltip top>
        <v-icon class="help-icon" color="primary" small slot="activator">mdi-information-outline</v-icon>
        <span>After submission, the cohort data is locked and cannot be changed. Please ensure all information is accurate.</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisConfirmClinicalVerification'] = this;
  },
}
</script>

<style lang="scss" scoped>
.help-icon {
  margin-bottom: 2px;
}
</style>